module.exports = __webpack_public_path__ + "assets/img/haveObtained_Exchange.4ff942e7.png";